export default () => {
  const scriptTagId = 'help-component'

  if (document.getElementById(scriptTagId) !== null) return

  const scriptTag = document.createElement('script')
  scriptTag.setAttribute('id', scriptTagId)
  scriptTag.setAttribute('type', 'application/javascript')
  scriptTag.setAttribute(
    'src',
    'https://jsd-widget.atlassian.com/assets/embed.js'
  )
  scriptTag.dataset.key = import.meta.env.VITE_JIRA_KEY
  scriptTag.dataset.baseUrl = 'https://jsd-widget.atlassian.com'
  scriptTag.dataset.jsdEmbedded = ''
  document.body.appendChild(scriptTag)

  setTimeout(() => {
    window.document.dispatchEvent(
      new Event('DOMContentLoaded', {
        bubbles: true,
        cancelable: true,
      })
    )
  }, 1000)
}
